import * as React from "react";
import ResetPasswordDialog from "../components/ResetPassword/ResetPasswordDialog";

import Panel from "../Panel";
import useLogin from "../hooks/useLogin";
import LoginForm from "../components/User/LoginForm";

export default function Login() {
  const { loginProps, dialogProps } = useLogin();

  return (
    <>
      <ResetPasswordDialog dialogProps={dialogProps} />
      <Panel>
        <LoginForm loginProps={loginProps} dialogProps={dialogProps} />
      </Panel>
    </>
  );
}
